export enum KommunikationsArtEnum {
  EMAIL = "EMAIL",
  TELEFON = "TELEFON",
}
